import * as collectionService from '../../../services/data-collection.service';
import { useEffect, useMemo, useState } from "react";
import { toast } from "react-toastify";
import { Parameters } from "../../../components/asheetPlugin/search-parameters/parameters";
import { testData } from '../../../services/test-data.service';
import { AppEnum } from '../../../constants/app-enum';
import { sortMethod } from '../../../shared/code-challanges/code-challanges';

export const SearchParameterController = ({ parameter, index, state, setState, setSearchOptionsParameters, searchOptionsParameters, isPopup, setIsParameterPopulated, excelDataState, selectedConnection }) => {

    const complexTypeValue = useMemo(() => {
        const parsedComplexTypeValue = JSON.parse(parameter?.complexTypeValue);

        if (parsedComplexTypeValue) {
            Object.assign(parsedComplexTypeValue, {
                // parameterName: parameter.parameterName,
                parameterName: state?.hasMergeCollections ? parameter.parameterName + parameter?.childCollectionUId : parameter.parameterName,
                childCollectionUId: parameter?.childCollectionUId //for merge collection (childCollectionUId will only not null in case of mergeCollection)
            });
        }

        return parsedComplexTypeValue;
    }, [parameter?.complexTypeValue, parameter?.parameterName]);

    const [multiSelectedFields, setMultiSelectedFields] = useState([]);
    const [optionValues, setOptionValues] = useState([]);
    const [multiSelectedTextFields, setMultiSelectedTextFields] = useState([]);
    const dateString = parameter?.parameterValue || parameter?.defaultValue;
    const dateObject = new Date(dateString);

    useEffect(() => {
        let isDynamicListOptionsPresent = state?.dynamicListOptions && state.dynamicListOptions[complexTypeValue?.parameterName];

        let isDynamicList = parameter?.sysDataTypeId == AppEnum.DataTypeId.DynamicList;
        if (isDynamicList && !isDynamicListOptionsPresent) {
            getCollectionDetail(complexTypeValue);
        }
        else if (isDynamicList && parameter.isMultiSelectList && isDynamicListOptionsPresent) {
            const options = state.dynamicListOptions[complexTypeValue?.parameterName];
            const paramWithDefaultValue = options?.filter((i) => i.value == complexTypeValue?.DefaultValue);
            handleMultiSelectParameterValues(options, paramWithDefaultValue);
        }

        if (parameter.parameterTypeCD == AppEnum.ParameterTypeValue.MultiValuedTextBox) {
            let paramValues = [];
            if (parameter?.parameterValue) {
                try {
                    paramValues = JSON.parse(parameter.parameterValue);
                    if (!Array.isArray(paramValues)) {
                        paramValues = [parameter.parameterValue];
                        paramValues = paramValues?.flat();
                    }
                } catch (e) {
                    paramValues = [parameter.parameterValue];
                    paramValues = paramValues?.flat();
                }
            }
            handleMultiSelectTextFields(null, paramValues);
        }

    }, [parameter])

    useEffect(() => {
        if (parameter.isMultiSelectList && complexTypeValue && parameter?.sysDataTypeId === AppEnum.DataTypeId.List) {

            let options = complexTypeValue.map(item => ({
                label: item.Label,
                value: item.Value,
                default: item.Default
            }));
            const paramWithDefaultValue = options?.filter((i) => i.default);
            handleMultiSelectParameterValues(options, paramWithDefaultValue);
        }
    }, [])

    const getCollectionDetail = async (parsedComplexTypeValue) => {
        try {
            const response = await collectionService.getCollectionDetails(parsedComplexTypeValue?.DataCollectionUId, true);
            if (response?.hasError) {
                toast.error(response?.errorMessage);
            }
            else if (response?.data) {

                // Handling for merge collections parameters
                if (state?.hasMergeCollections && state?.mergeParamsCallingCollectionUId) {
                    if (state?.mergeParamsCallingCollectionUId[parsedComplexTypeValue?.parameterName]) {
                        state.connectionUId = state?.mergeParamsCallingCollectionUId[parsedComplexTypeValue?.parameterName]
                    }
                }

                let testDataCollectionModal = {
                    connectionUId: response?.data?.connectionUId,
                    sysCollectionTypeId: response?.data?.sysCollectionTypeId,
                    sourceName: response?.data?.sourceName,
                    restRequestMethod: response?.data?.restRequestMethod,
                    restRequestIsAsync: response?.data?.restRequestIsAsync,
                    restBody: response?.data?.restBody,
                    restSendAsCD: response?.data?.restSendAsCD,
                    collectionParameters: response?.data?.collectionParameters,
                    collectionColumns: response?.data?.collectionColumns,
                    uId: response?.data?.uId,
                    returnFlatternData: response?.data?.sysCollectionTypeId === 7 ? true : false,
                    sourceNamePart4: response?.data?.sourceNamePart4,
                    IsASTenantUIdApplicable: false,
                    restDataTransformationScript: response?.data?.restDataTransformationScript,
                    callingConnectionUId: response?.data?.useTemplateConnection ? null : state?.connectionUId,
                    flattenLikeSql: response?.data?.flattenLikeSql || false,
                    excludedProperties: response?.data?.excludedProperties || "",
                    selectedConnection: selectedConnection,
                }

                let isForExecutedData = false; 
                const collectionParameters = response?.data?.collectionParameters || [];
                collectionParameters.forEach(param => {
                    if (param.sysDataTypeId === AppEnum.DataTypeId.DynamicList) {
                        const complexTypeValue = JSON.parse(param.complexTypeValue);
                        if (!param.parameterValue) {
                            param.parameterValue = complexTypeValue?.DefaultValue;
                        }
                        //Handling the case where the parameter have cascading prams and the used parameter has the saved values in parent collection
                        searchOptionsParameters?.forEach(sParam => {
                            if (sParam.sysDataTypeId == AppEnum.DataTypeId.DynamicList) {
                                if (state?.hasMergeCollections && (sParam?.childCollectionUId != parsedComplexTypeValue?.childCollectionUId)) {
                                    return;
                                }
                                try {
                                    let parentComplexTypeValue = JSON.parse(sParam.complexTypeValue);
                                    let key = state?.hasMergeCollections ? sParam.parameterName + sParam?.childCollectionUId : sParam.parameterName;
                                    if (parentComplexTypeValue.DataCollectionUId === complexTypeValue?.DataCollectionUId && key != parsedComplexTypeValue?.parameterName) {
                                        let savedParamValues = (state?.hasMergeCollections && state?.mergeCollectionsSavedParamValues && state?.mergeCollectionsSavedParamValues[sParam?.childCollectionUId]) ? state?.mergeCollectionsSavedParamValues[sParam?.childCollectionUId] : state?.savedParameterValue;
                                        if (sParam?.enableSavingParameterValue && savedParamValues) {
                                            let savedValues = JSON.parse(savedParamValues);
                                            let collParamId = state?.hasMergeCollections ? sParam?.collectionParameterId : sParam?.id;
                                            let savedParamValue =  savedValues?.find(i => i.Id == collParamId);
                                            if (savedParamValue) {
                                                let value = savedValues?.find(i => i.Id == collParamId)?.Value;
                                                param.parameterValue = value;
                                                
                                                let updatedComplexTypeValue = JSON.parse(param.complexTypeValue);
                                                updatedComplexTypeValue.DefaultValue = value;
                                                param.complexTypeValue = JSON.stringify(updatedComplexTypeValue);
                                                param.childComplexTypeValue = sParam.childComplexTypeValue ? JSON.stringify(updatedComplexTypeValue) : sParam.childComplexTypeValue;

                                                isForExecutedData = true;
                                            }
                                        }
                                    }
                                } catch (e) {
                                    console.error('Error parsing complexTypeValue:', e);
                                }
                            }
                        });


                    }
                });
                setState((prevState) => ({
                    ...prevState,
                    dynamicListCollectionModel: {
                        ...prevState.dynamicListCollectionModel,
                        [parsedComplexTypeValue?.parameterName]: testDataCollectionModal,
                    },
                }));

                return getDynamicList(testDataCollectionModal, parsedComplexTypeValue, isForExecutedData); 
            }
        } catch (error) {

        }
    }

    const getDynamicList = async (model, parsedComplexTypeValue, isForExecutedData) => {
        try {
            testData(model, null, getDynamicListOptions, parsedComplexTypeValue, null, null, null, isForExecutedData);
        } catch (error) {
            toast.error(error);
        }
    }

    const getDynamicListOptions = (data, parsedComplexTypeValue) => {
        const displayColumn = parsedComplexTypeValue?.DisplayColumn;
        const valueColumn = parsedComplexTypeValue?.ValueColumn;
        let options = [];

        if (!displayColumn || !valueColumn) {
            return;
        }

        if (data && data?.length === undefined) {
            var displayColumnList = data[displayColumn]?.filter(value => value !== null)
            var valueColumnList = data[valueColumn]?.filter(value => value !== null)

            options = displayColumnList.map((label, index) => ({
                label,
                value: valueColumnList[index]
            }));
        }
        else if (data?.length) {
            const isValueColumnArray = Array.isArray(complexTypeValue?.ValueColumn);
            options = data?.map(item => ({
                label: item[displayColumn],
                value: isValueColumnArray
                    ? complexTypeValue?.ValueColumn.reduce((acc, col) => {
                        if (item[col] !== undefined) {
                            acc[col] = item[col];
                        }
                        return acc;
                    }, {})
                    : item[valueColumn],
                isSelected: false
            }));
        }

        if (!state?.dynamicListOptions) {
            let savedParamValues = (state?.hasMergeCollections && state?.mergeCollectionsSavedParamValues && state?.mergeCollectionsSavedParamValues[parameter?.childCollectionUId]) ? state?.mergeCollectionsSavedParamValues[parameter?.childCollectionUId] : state?.savedParameterValue;
            if (excelDataState?.isCommandFromExcel && excelDataState?.parameters) {  //for syncing params coming from excel
                let excelParameters = JSON.parse(excelDataState?.parameters);
                if (excelParameters) {
                    let paramValue =  excelParameters?.find(i => i.Id == parameter?.id);
                    if (paramValue) {
                        let value = paramValue?.ParameterValue;
                    if (parameter.isMultiSelectList && value) {
                        value = Array.isArray(value) ? value : JSON.parse(value);
                    } else {
                        value = [value];
                    }

                    options = options?.filter(option => option?.label !== null)?.map(option => {
                        if (value.includes(option.value)) {
                            return {
                                ...option,
                                isSelected: true,
                            };
                        }
                        return option;
                    });
                    }
                }
            }
            else if (parameter?.enableSavingParameterValue && savedParamValues) {
                let savedValues = JSON.parse(savedParamValues);
                let savedParamValue =  savedValues?.find(i => i.Id == parameter?.id);
                if (savedParamValue) {
                    let value = savedValues?.find(i => i.Id == parameter?.id)?.Value;
                    if (parameter.isMultiSelectList && value) {
                        value = Array.isArray(value) ? value : JSON.parse(value);
                    } else {
                        value = [value];
                    }

                    options = options?.filter(option => option?.label !== null)?.map(option => {
                        if (value.includes(option.value)) {
                            return {
                                ...option,
                                isSelected: true,
                            };
                        }
                        return option;
                    });
                }
            }
            else {
                options = options?.filter(option => option?.label !== null)?.map(option => {
                    if (option.value == parsedComplexTypeValue?.DefaultValue) {
                        return {
                            ...option,
                            isSelected: true,
                        };
                    }
                    return option;
                });
            }
        }
        if (options.length > 0) {
            options = sortMethod(options, "label")
        }
        if (parameter.isMultiSelectList) {
            const paramWithDefaultValue = options?.filter((i) => i.value == parsedComplexTypeValue?.DefaultValue);
            handleMultiSelectParameterValues(options, paramWithDefaultValue, parsedComplexTypeValue);
        }

        handleSelectValueCascadedDropdown(parsedComplexTypeValue, options, null, true);
    };


    const getPreviousParameters = () => {
        return isPopup ? [...searchOptionsParameters] : [...state?.searchParameters];
    }


    const handleOnInputChange = (e, index, isComplexTypeValue, isDynamicList, isUpdatingCascadedValues) => {
        let value = e?.target?.value;

        let prevParams = getPreviousParameters()
        if (index >= 0 && index < prevParams?.length) {

            if (isComplexTypeValue) {
                let complexTypeValue = JSON.parse(prevParams[index]?.complexTypeValue);
                let complexParamValue = null;

                if (!isDynamicList) {
                    complexParamValue = complexTypeValue?.find(i => i.Value == value)?.Value;
                }

                let isValueColumnArray = typeof value === 'object' && value !== null;
                value = isValueColumnArray ? JSON.stringify(value) : value;
                prevParams[index].parameterValue = isDynamicList ? value : complexParamValue;

                if (isDynamicList && state?.dynamicListCollectionModel && !isUpdatingCascadedValues) {
                    Object.assign(complexTypeValue, {
                        // parameterName: prevParams[index].parameterName,
                        parameterName: state?.hasMergeCollections ? prevParams[index].parameterName + prevParams[index]?.childCollectionUId : prevParams[index].parameterName,
                        childCollectionUId: prevParams[index]?.childCollectionUId
                    });
                    handleCascadingDropdowns(complexTypeValue, value, false);
                    handleSelectValueCascadedDropdown(complexTypeValue, state?.dynamicListOptions?.[complexTypeValue.parameterName], value, false);
                }
            }
            else {
                prevParams[index].parameterValue = value;
            }
        }
        if (isPopup) {
            setSearchOptionsParameters(prevParams);
        }
        else {
            setState((prevState) => { return { ...prevState, collectionParameters: prevParams } });
        }
    }

    const handleMultiSelectedFields = (e, value, index, isDefaultValue, isUpdatingCascadedValues, isOnChange) => {

        if (!isDefaultValue) {
            setMultiSelectedFields(value);
        }
        let prevParams = getPreviousParameters()

        if (prevParams[index]?.isMultiSelectList && prevParams[index]?.sysDataTypeId == AppEnum.DataTypeId.DynamicList && !isUpdatingCascadedValues && (isOnChange || value?.length)) {
            handleSelectValueCascadedDropdown(complexTypeValue, state?.dynamicListOptions?.[complexTypeValue?.parameterName], value)
            if (isOnChange) {
                handleCascadingDropdowns(complexTypeValue, value, true);
            }
        }

        if (value && value?.length > 0) {
            const values = value?.map(item => item.value);

            if (index >= 0 && index < prevParams?.length) {
                prevParams[index].parameterValue = JSON.stringify(values);;
            }
        }
        else {
            if (index >= 0 && index < prevParams?.length) {
                prevParams[index].parameterValue = "";
            }
        }

        if (isPopup) {
            setSearchOptionsParameters(prevParams);
        }
        else {
            setState((prevState) => { return { ...prevState, collectionParameters: prevParams } });
        }
    }

    const handleMultiSelectParameterValues = (options, paramWithDefaultValue, parsedComplexTypeValue) => {
        let paramValues = [];
        if (parameter?.parameterValue) {
            try {
                // Attempt to parse the parameterValue
                paramValues = JSON.parse(parameter.parameterValue);

                // If parsing succeeds, ensure it is an array
                if (!Array.isArray(paramValues)) {
                    paramValues = [parameter.parameterValue];
                    paramValues = paramValues?.flat();
                }
            } catch (e) {
                // If parsing fails, treat it as a single value in an array
                paramValues = [parameter.parameterValue];
                paramValues = paramValues?.flat();
            }
        }
        setOptionValues(options);

        // const paramIndex = searchOptionsParameters?.findIndex(i => i.parameterName == parsedComplexTypeValue?.parameterName)
        const paramIndex = searchOptionsParameters?.findIndex(i => (state?.hasMergeCollections ? i.parameterName + i.childCollectionUId : i.parameterName) == parsedComplexTypeValue?.parameterName)

        const containsOnlyDefault = paramValues.length > 0 &&
            paramValues?.every(value =>
                paramWithDefaultValue?.some(option => option.value === value)
            );

        if (containsOnlyDefault) {
            setMultiSelectedFields(paramWithDefaultValue);
            handleMultiSelectedFields(null, paramWithDefaultValue, (paramIndex != -1) ? paramIndex : index, true)
        }
        else {
            const selectedOptions = options?.filter(option => paramValues?.includes(option.value))
                .sort((a, b) => paramValues.indexOf(a.value) - paramValues.indexOf(b.value));
            handleMultiSelectedFields(null, selectedOptions, (paramIndex != -1) ? paramIndex : index, false);
        }
    }


    const handleCascadingDropdowns = (parentComplexValue, value, isMultiSelect) => {
        const dynamicListModels = state?.dynamicListCollectionModel || {};      
        let prevParams = isPopup ? [...searchOptionsParameters] : [...state?.collectionParameters];
        Object.keys(dynamicListModels).forEach(key => {
            let isChildDropdownPresent = false
            if (key !== parentComplexValue?.parameterName) {
                const modelData = dynamicListModels[key];
                const collectionParameters = modelData.collectionParameters || [];

                collectionParameters.forEach(param => {
                    if (param.sysDataTypeId == AppEnum.DataTypeId.DynamicList) {
                        try {
                            const complexTypeValue = JSON.parse(param.complexTypeValue);
                            if (complexTypeValue.DataCollectionUId === parentComplexValue?.DataCollectionUId) {
                                param.parameterValue = value;
                                isChildDropdownPresent = true
                            }
                        } catch (e) {
                            console.error('Error parsing complexTypeValue:', e);
                        }
                    }
                });
                if (isChildDropdownPresent) {
                    for (const param of prevParams) {
                        if (param.sysDataTypeId == AppEnum.DataTypeId.DynamicList) {
                            if (state?.hasMergeCollections && (param?.childCollectionUId != parentComplexValue?.childCollectionUId)) {
                                continue;
                            }

                            let complexTypeValue = JSON.parse(param.complexTypeValue);
                            if (complexTypeValue.DataCollectionUId === modelData?.uId && (state?.hasMergeCollections ? param.parameterName + param?.childCollectionUId : param.parameterName) == key) {
                                Object.assign(complexTypeValue, {
                                    // parameterName: param.parameterName,
                                    parameterName: state?.hasMergeCollections ? param.parameterName + param?.childCollectionUId : param.parameterName,
                                    childCollectionUId: param?.childCollectionUId
                                });

                                if (isMultiSelect) {
                                    modelData.collectionParameters = modelData.collectionParameters.map(param => {
                                        return { ...param, parameterValue: Array.isArray(param.parameterValue) ? JSON.stringify(param.parameterValue.map(i => i.value)) : param.parameterValue };
                                    });;
                                }

                                getDynamicList(modelData, complexTypeValue, true);
                                break;
                            }
                        }
                    }
                }
            }
        });
    };

    const handleSelectValueCascadedDropdown = (parsedComplexTypeValue, options, selectedValues, isSetParamValues) => {

        let isMultiSelectDropDownForCascading = false;
        let selectedParamIndex = null;
        let prevParams = isPopup ? [...searchOptionsParameters] : [...state?.collectionParameters];

        for (const param of prevParams) {
            if (param.sysDataTypeId === AppEnum.DataTypeId.DynamicList) {
                const complexTypeValue = JSON.parse(param.complexTypeValue);
                if (complexTypeValue.DataCollectionUId === parsedComplexTypeValue?.DataCollectionUId) {
                    selectedParamIndex = prevParams?.indexOf(param);
                    if (param?.isMultiSelectList){
                        isMultiSelectDropDownForCascading = true;
                        break;
                    }
                }
            }
        }

        if (state?.dynamicListOptions?.[parsedComplexTypeValue?.parameterName]) {
            let selectedOptions = [];
            selectedOptions = selectedValues ? selectedValues : state.dynamicListOptions[parsedComplexTypeValue?.parameterName].filter(option => option.isSelected)
            let isArrayValue = Array.isArray(selectedOptions)
            options = options.map(option => {            
                let isValueObject = typeof option?.value === "object" && option.value !== null;
                let optionValue = isValueObject ? JSON.stringify(option.value) : option.value;
                const isSelectedOption = isArrayValue
                    ? selectedOptions.some(selected => selected.value == optionValue)
                    : optionValue == selectedValues;

                if (isSelectedOption && (selectedValues != "")) {
                    return {
                        ...option,
                        isSelected: true,
                    };
                }
                return {
                    ...option,
                    isSelected: false,
                };
            });

            if (isSetParamValues) {
                if (isMultiSelectDropDownForCascading) {
                    handleMultiSelectedFields(null, options?.filter(o => o.isSelected), selectedParamIndex, false, true);
                }
                else {
                    let value = options?.filter(o => o.isSelected)?.length > 0
                        ? options.filter(o => o.isSelected)[0]?.value
                        : "";
                    const e = {
                        target: {
                            value: value
                        }
                    };
                    handleOnInputChange(e, selectedParamIndex, true, true, true)
                }
            }
        }

        setState((prevState) => ({
            ...prevState,
            dynamicListOptions: {
                ...prevState.dynamicListOptions,
                [parsedComplexTypeValue?.parameterName]: options
            },
        }));

        if(setIsParameterPopulated){
            setIsParameterPopulated(true);
        }
    }

    const handleMultiSelectTextFields = (e, value) => {
        setMultiSelectedTextFields(value);
        let prevParams = getPreviousParameters()

        if (value && value?.length > 0) {
            if (index >= 0 && index < prevParams?.length) {
                prevParams[index].parameterValue = JSON.stringify(value);;
            }
        }
        else {
            if (index >= 0 && index < prevParams?.length) {
                prevParams[index].parameterValue = "";
            }
        }

        if (isPopup) {
            setSearchOptionsParameters(prevParams);
        }
        else {
            setState((prevState) => { return { ...prevState, collectionParameters: prevParams } });
        }
    }

    // const handleOnInputChangeCallback = useCallback(debounce(handleOnInputChange, 300), [])


    return (
        <Parameters
            parameter={parameter}
            index={index}
            dateObject={dateObject}
            complexTypeValue={complexTypeValue}
            handleOnInputChange={handleOnInputChange}
            handleMultiSelectedFields={handleMultiSelectedFields}
            multiSelectedFields={multiSelectedFields}
            optionValues={optionValues}
            multiSelectedTextFields={multiSelectedTextFields}
            handleMultiSelectTextFields={handleMultiSelectTextFields}
            state={state}/>
    )
}